export default __webpack_public_path__ + "static/media/arrowRightDark.a2943d2a.svg";